import { render, staticRenderFns } from "./x-range-slider.vue?vue&type=template&id=0a6fb7ac&"
import script from "./x-range-slider.vue?vue&type=script&lang=js&"
export * from "./x-range-slider.vue?vue&type=script&lang=js&"
import style0 from "./x-range-slider.vue?vue&type=style&index=0&id=0a6fb7ac&prod&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports